export default {
    requirements: {
        low: {
            id: 'low',
            name: 'Low',
            totalFootage: 25,
            staffing: 0.75,
            staffingCode: "da",
            equipment: [],
            software: [],
            otherItems: []
        },

        medium: {
            id: 'medium',
            name: 'Medium',
            totalFootage: 25,
            staffing:1.5,
            staffingCode: "da",
            equipment: [],
            software: [],
            otherItems: []
        },

        high: {
            id: 'high',
            name: 'High',
            totalFootage: 25,
            staffing: 2,
            staffingCode: "da",
            equipment: [],
            software: [],
            otherItems: []
        },
    },

    ratingDetails: [
        {
            id: 'level',
            type: 'enum',
            required: false,
            component: 'PulloutQuestionMultiSwitchList',
            default: 0,
            label: "Level of Need:",
            options: [
                {
                    id: "none",
                    label: "None",
                    value: 0
                },

                {
                    id: "low",
                    label: "Low",
                    description: "up to 6 routes per/day",
                    value: 1
                },
                {
                    id: "medium",
                    label: "Medium",
                    description: "up to 12 routes per/day",
                    value: 2
                },
                {
                    id: "high",
                    label: "High",
                    description: "more than 12 routes per/day",
                    value: 3
                }
            ]
        }

    ]
}
